// src/utils/naturalCode.ts
import type { ProductLite } from "../components/ProductsPicker";

function splitCode(code: string) {
  const m = String(code).trim().match(/^([A-Za-z]+)(\d+)$/);
  if (!m) return { prefix: code, num: Number.NaN };
  return { prefix: m[1], num: parseInt(m[2], 10) };
}

export function naturalCodeCompare(a: { code: string }, b: { code: string }) {
  const A = splitCode(a.code);
  const B = splitCode(b.code);
  const p = A.prefix.localeCompare(B.prefix, undefined, { sensitivity: "base" });
  if (p !== 0) return p;
  const aHas = Number.isFinite(A.num);
  const bHas = Number.isFinite(B.num);
  if (aHas && bHas) {
    if (A.num !== B.num) return A.num - B.num;
  } else if (aHas !== bHas) {
    return aHas ? -1 : 1;
  }
  return a.code.localeCompare(b.code, undefined, { sensitivity: "base" });
}
